/*
 * Olavson — Geschenk- und Staffelbalken (<olv-tier-bar>)
 * Markup-Platzhalter + Konfiguration: snippets/olv-tier-bar.liquid (dort auch die Architektur-Notiz).
 *
 * Varianten (Handoff Louis, 24.09.2026): 1a = ein Geschenk, 2a = 2–3 Geschenk-Stufen, 2b = Prozent-Staffel.
 *
 * Sicherungen gegen Falschversprechen (aus gift-progress-bar + qty-advantage-bar uebernommen):
 *  - Geschenk: Rabattcode angewendet -> Balken aus (der Gift-Watcher entfernt das Geschenk und zeigt seinen
 *    Hinweis). Geschenkzeile eines gezeigten Slots nicht voll rabattiert -> aus + console.warn.
 *    "Erreicht" (Text, Haken, Farbbild) nur, wenn das Geschenk mit 0 € im Warenkorb liegt. Direkt nach dem
 *    Ueberschreiten legt der Gift-Watcher das Geschenk asynchron nach (~0,2–1,5 s): Solange bleibt die
 *    Anzeige auf dem letzten gesicherten Stand. Liegt es nach PENDING_MS (3 s) immer noch nicht gratis im
 *    Warenkorb (Bxgy fehlt, ausverkauft, Code), blendet sich der Balken aus.
 *  - Staffel: tatsaechlich gewaehrter % (line-level Allocation, value_type percentage, kein Code, keine
 *    Geschenkzeile) != erwarteter % der erreichten Stufe -> aus + console.warn (Shopify-Rabatte und
 *    Theme-Settings weichen ab). Wie bisher nur, wenn ueberhaupt eine solche Allocation existiert.
 *    Den Nachlass geben seit Oktober 2026 native automatische Shopify-Rabatte (Klasse Produkt, Collection
 *    staffel-basis-intern, je Stufe ein Rabatt mit Mindestbestellwert). Die flex-discount-App ist deinstalliert.
 *
 * Drawer und /cart nachziehen (20.10.2026, Abnahme 28.09. Punkt 7, Fehlerbild 2): siehe syncViews() unten.
 *
 * Modus zur Laufzeit (19.10.2026): Die Konfiguration traegt "pct" (mit optionalen Zeitfenstern) und "gift".
 * In einem Staffel-Fenster gilt die Staffel, ausserhalb die Geschenk-Stufen. _applyWindow() setzt daraus
 * this._cfg ({mode, tiers, base, excl, near, currencyCode, t}); der restliche Code arbeitet damit wie vorher.
 */
(function () {
  if (window.__olvTierBar) return;
  window.__olvTierBar = 1;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var PENDING_MS = 3000;
  var MIN_GAP = 48; // Mindestabstand Haltepunkte (Mitte zu Mitte, px)
  var STOP = 40;    // Haltepunkt-Kantenlaenge (px)
  var REG = {};     // Kontext ('drawer' | 'page') -> lebende Instanz
  /* Zustand fuer syncViews (Drawer und /cart nachziehen). Hier oben, weil customElements.define weiter unten
     vorhandene Elemente sofort hochstuft und update() dann schon laeuft. */
  var SYNC_DELAY = 5000; /* ms nach der Fenstergrenze; gemessen am 20.10.2026, siehe Abschlussbericht */
  var boundaryAt = null, boundaryTimer = null, syncSeq = 0, lastSig = null;
  var CHECK = '<svg viewBox="0 0 10 10" aria-hidden="true"><path d="M2 5.2l2 2 4-4.4" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var LOCK = '<i class="otb-lock__shackle"></i><i class="otb-lock__body"></i>';

  /* ---------- Warenkorb-Helfer ---------- */
  function isGiftLine(ln) { return !!(ln.properties && (ln.properties._gift || ln.properties._lp_free_gift)); }
  /* Nur Prozent-Modus: Produkte ausserhalb von staffel-basis-intern zaehlen nicht (der Shopify-Rabatt zaehlt sie nicht
     zum Mindestbestellwert). Seit 21.10.2026 als Regel (Kopf von snippets/olv-tier-bar.liquid):
       cfg.excl       zusaetzliche IDs aus dem Setting (Sonderfaelle)
       cfg.exclTypes  Produkttypen, kleingeschrieben; /cart.js liefert product_type
       TAG_EXCL       IDs mit Ausschluss-Tag, von Liquid je Warenkorb gerendert (data-otb-excl). Wird nur ergaenzt,
                      nie geleert: ein Produkt verliert seinen Tag nicht waehrend der Sitzung. */
  var TAG_EXCL = {};
  function noteTagExcl(text) {
    if (!text) return;
    try { var a = JSON.parse(text); for (var i = 0; i < a.length; i++) TAG_EXCL[Number(a[i])] = 1; } catch (e) {}
  }
  function isExcluded(ln, cfg) {
    var pid = Number(ln.product_id), t = String(ln.product_type || '').toLowerCase();
    return (cfg.excl || []).indexOf(pid) >= 0 || (cfg.exclTypes || []).indexOf(t) >= 0 || TAG_EXCL[pid] === 1;
  }
  function baseTotal(c, cfg) {
    var s = 0, it = (c && c.items) || [];
    for (var i = 0; i < it.length; i++) {
      var ln = it[i];
      if (ln.gift_card || isGiftLine(ln) || (cfg && cfg.mode === 'pct' && isExcluded(ln, cfg))) continue;
      s += ln.original_line_price || 0;
    }
    return s;
  }
  function appliedCodes(c) {
    var out = [], dc = (c && c.discount_codes) || [];
    for (var i = 0; i < dc.length; i++) { if (dc[i] && dc[i].applicable && dc[i].code) out.push(String(dc[i].code).toLowerCase()); }
    return out;
  }
  function fetchCart() { return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(noteSrv).then(function (r) { return r.json(); }); }

  /* ---------- Zeitfenster je Geschenk-Stufe (01.10.2026) ----------
     Stufen tragen from/to (Epoch-Sekunden, null = offen; snippets/olv-gift-window.liquid). Gezaehlt werden nur Stufen mit
     from <= jetzt < to. "Jetzt" = Serverzeit aus dem Date-Header der letzten /cart.js-Antwort (gemeinsamer Abstand zur Browseruhr in
     window.__olvSrvSkew, auch vom Gift-Watcher gesetzt). Solange keine Serverzeit bekannt ist und eine Stufe ein Fenster hat, bleibt
     der Balken verborgen und holt sie sich (kein Versprechen auf Basis einer falsch gehenden Browseruhr). */
  function noteSrv(r) { try { var d = Date.parse(r.headers.get('Date')); if (!isNaN(d)) window.__olvSrvSkew = d - Date.now(); } catch (e) {} return r; }
  function srvKnown() { return typeof window.__olvSrvSkew === 'number'; }
  function srvNow() { return Math.floor((Date.now() + (srvKnown() ? window.__olvSrvSkew : 0)) / 1000); }
  function hasWindow(t) { return t.from != null || t.to != null; }
  function inWindow(t, now) { return (t.from == null || now >= t.from) && (t.to == null || now < t.to); }

  /* ---------- Format ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }
  function fill(tpl, map) { return String(tpl || '').replace(/\{(\w+)\}/g, function (m, k) { return map.hasOwnProperty(k) ? map[k] : m; }); }

  /* ---------- Komponente ---------- */
  var OlvTierBar = class extends HTMLElement {
    connectedCallback() {
      var ctx = this.dataset.context || 'drawer', live = REG[ctx];
      if (live && live !== this && !live.isConnected) {
        /* Neu gerenderter Platzhalter: bestehende Instanz uebernimmt seinen Platz (Transitions laufen weiter).
           Nur eine geaenderte Konfiguration (Theme-Editor) wird uebernommen, nicht der Warenkorb-Stand. */
        noteTagExcl(this._readText('[data-otb-excl]'));
        var cfgText = this._readText('[data-otb-config]');
        if (cfgText && cfgText !== live._cfgText) live._setConfig(cfgText);
        else if (live._cart) live.update(live._cart);
        this.replaceWith(live);
        return;
      }
      if (live === this && this._ready) return;
      REG[ctx] = this;
      this._init();
    }

    _readText(sel) { var n = this.querySelector(sel); return n ? n.textContent : ''; }

    _init() {
      this._ready = true;
      this._pendingTimer = null;
      this._shown = false;
      noteTagExcl(this._readText('[data-otb-excl]'));
      this._setConfig(this._readText('[data-otb-config]'));
      var cart = null;
      try { cart = JSON.parse(this._readText('[data-otb-cart]')); } catch (e) {}
      if (cart && cart.items) this.update(cart); else fetchCart().then(this.update.bind(this)).catch(function () {});
    }

    _setConfig(text) {
      try { this._raw = JSON.parse(text); } catch (e) { this._raw = null; }
      this._cfg = null;
      this._tierSig = null;
      this._cfgText = text;
      this._built = null;
      this._view = null;
      if (this._raw && this._raw.gift) this._loadGiftFallbacks();
      if (this._cart) this.update(this._cart);
    }

    /* Bild/Wert je Stufe: Theme-Setting, sonst erste Gift-Variante via /variants/<id>.js (sessionStorage-Cache). */
    _loadGiftFallbacks() {
      var self = this, tiers = this._raw.gift.tiers || [];
      tiers.forEach(function (t) {
        if ((t.img && t.value) || !t.gifts || !t.gifts[0]) return;
        var id = t.gifts[0], key = 'olv_tier_var_' + id, cached = null;
        try { cached = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) {}
        var apply = function (v) {
          if (!v) return;
          if (!t.img && v.img) t.img = v.img;
          if (!t.value && v.value) t.value = v.value;
          self._built = null; // Bild/Label neu aufbauen
          if (self._cart) self.update(self._cart);
        };
        if (cached) { apply(cached); return; }
        fetch(ROOT + 'variants/' + id + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (v) {
            if (!v) return;
            var src = v.featured_image && v.featured_image.src;
            var data = { img: src ? src.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : null, value: v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : v.price };
            try { sessionStorage.setItem(key, JSON.stringify(data)); } catch (e) {}
            apply(data);
          }).catch(function () {});
      });
    }

    /* ---------- Berechnung ---------- */
    /* Modus und aktive Stufen fuers Jetzt in this._cfg setzen. false = nichts zu zeigen.
       Staffel: ohne Fenster immer an; mit Fenstern nur innerhalb eines davon (19.10.2026). Sonst Geschenk-Stufen mit
       eigenem Fenster. Hat irgendetwas ein Fenster, wird erst mit bekannter Serverzeit entschieden (vorher verborgen). */
    _applyWindow() {
      var raw = this._raw, self = this;
      var pw = raw.pct ? (raw.pct.windows || []) : [], gt = raw.gift ? (raw.gift.tiers || []) : [];
      if ((pw.length || gt.some(hasWindow)) && !srvKnown()) {
        if (!this._srvAsked) { this._srvAsked = true; fetchCart().then(function (c) { self.update(c); }).catch(function () {}); }
        return false;
      }
      var now = srvNow(), next = null, nextPct = false;
      pw.concat(gt).forEach(function (t) { [t.from, t.to].forEach(function (b) { if (b != null && b > now && (next === null || b < next)) next = b; }); });
      pw.forEach(function (w) { if (w.from === next || w.to === next) nextPct = true; });
      if (next !== null) scheduleBoundary(next, now, nextPct);
      var mode = null, act = [];
      /* 22.10.2026: ohne Fenster nie aktiv (Liquid gibt die Staffel dann gar nicht erst aus; hier zur Sicherheit doppelt) */
      if (raw.pct && pw.length && pw.some(function (w) { return inWindow(w, now); })) { mode = 'pct'; act = raw.pct.tiers || []; }
      else if (raw.gift) { act = gt.filter(function (t) { return inWindow(t, now); }); if (act.length) mode = 'gift'; }
      if (!mode || !act.length) return false;
      var sig = mode + '|' + act.map(function (t) { return t.slot || t.threshold; }).join(',');
      if (sig !== this._tierSig) {
        this._tierSig = sig;
        this._cfg = { mode: mode, tiers: act, near: raw.near, currencyCode: raw.currencyCode, t: raw.t,
          base: mode === 'pct' ? (raw.pct.base || 0) : 0, excl: mode === 'pct' ? (raw.pct.excl || []) : [],
          exclTypes: mode === 'pct' ? (raw.pct.exclTypes || []) : [] };
        this._built = null;
      }
      return true;
    }

    update(cart) {
      if (!cart || !cart.items || !this._raw) return;
      this._cart = cart;
      lastSig = fullSig(cart); /* zuletzt gesehener Stand fuer den Abgleich bei Tab-Rueckkehr */
      if (!this._applyWindow()) { this._clearPending(); this._hide('ausserhalb Zeitfenster'); return; }
      var cfg = this._cfg;
      if (!cart.item_count) { this._hide('leer'); return; }
      /* Ausgenommene Produkte im Warenkorb (20.10.2026: Welcome-Pfanne, Wiederbeschichtung): dann nicht
         „… auf deinen Warenkorb“ versprechen, sondern den neutralen Text p_next (siehe _texts). */
      this._hasExcl = cfg.mode === 'pct' && cart.items.some(function (ln) { return !ln.gift_card && !isGiftLine(ln) && isExcluded(ln, cfg); });
      var total = baseTotal(cart, cfg), tiers = cfg.tiers, n = tiers.length, max = tiers[n - 1].threshold;
      var reachedCount = 0;
      for (var i = 0; i < n; i++) { if (total >= tiers[i].threshold) reachedCount = i + 1; }

      if (cfg.mode === 'gift') {
        if (appliedCodes(cart).length) { this._clearPending(); this._hide('Rabattcode angewendet'); return; }
        var free = {}, unpaid = null, reachedGift = {};
        for (var k = 0; k < reachedCount; k++) (tiers[k].gifts || []).forEach(function (g) { reachedGift[g] = 1; });
        cart.items.forEach(function (ln) {
          if (!isGiftLine(ln)) return;
          var vid = String(ln.variant_id || ln.id);
          /* Unbezahlte Geschenkzeile einer NICHT erreichten Stufe ist ein Uebergang (der Watcher nimmt sie gleich
             raus) und kein Falschversprechen — der Balken zeigt dort ohnehin "noch nicht erreicht". */
          if ((ln.final_line_price || 0) === 0) free[vid] = 1; else if (reachedGift[vid]) unpaid = vid;
        });
        var unsecured = false;
        for (var j = 0; j < reachedCount; j++) {
          if (!(tiers[j].gifts || []).every(function (g) { return free[g]; })) unsecured = true;
        }
        if (unpaid || unsecured) {
          /* Gift-Watcher legt das Geschenk gerade nach (oder die Allocation kommt ~400 ms spaeter): letzten
             gesicherten Stand halten. Erst nach PENDING_MS gilt es als echter Fehler. */
          if (this._pendingExpired) {
            if (unpaid) console.warn('[Geschenk-Balken] ausgeblendet: Geschenk-Variante ' + unpaid + ' ist nicht voll rabattiert — Bxgy-Rabatt in Shopify und Geschenk-Slot abgleichen.');
            this._hide(unpaid ? 'Geschenk nicht voll rabattiert' : 'Schwelle erreicht, Geschenk nicht gratis im Warenkorb');
            return;
          }
          this._startPending();
          return;
        }
      } else {
        var expected = reachedCount ? tiers[reachedCount - 1].pct : (cfg.base || 0);
        var actual = this._actualPct(cart);
        if (actual >= 0 && expected > 0 && actual !== expected) {
          console.warn('[Staffel-Balken] ausgeblendet: gewaehrt ' + actual + ' % != erwartet ' + expected + ' % — Theme-Settings (Prozent-Staffel) und die automatischen Shopify-Rabatte (Collection staffel-basis-intern) abgleichen.');
          this._hide('Prozent weicht ab');
          return;
        }
      }
      this._clearPending();
      this._render(total, max, reachedCount);
    }

    /* Gegenstueck zu snippets/olv-tier-alloc.liquid (20.10.2026 geprueft): schliesst Codes ueber type und Titel aus,
       setzt type 'automatic' nicht voraus (ist leer). Bewusst OHNE Abgleich auf die Stufen-Prozente: Gibt Shopify
       einen Prozentsatz, den die Settings nicht kennen, soll der Balken sich ausblenden statt Falsches zu zeigen. */
    _actualPct(cart) {
      var codes = appliedCodes(cart), actual = -1;
      cart.items.forEach(function (ln) {
        if (isGiftLine(ln)) return; // 100-%-Bxgy der Geschenkzeile ist keine Staffel
        (ln.line_level_discount_allocations || []).forEach(function (a) {
          var da = a && a.discount_application;
          if (!da || da.value_type !== 'percentage' || da.type === 'discount_code') return;
          /* 0-€-Allocation: Shopify markiert die "Buy"-Zeile einer Bxgy-Aktion so (Guard wie in line-item.liquid) — kein Staffel-% */
          if (!(parseFloat(a.amount) > 0)) return;
          if (da.title && codes.indexOf(String(da.title).toLowerCase()) >= 0) return;
          actual = Math.round(parseFloat(da.value));
        });
      });
      return actual;
    }

    _startPending() {
      var self = this;
      if (this._pendingTimer) return;
      this._pendingTimer = setTimeout(function () {
        self._pendingTimer = null;
        self._pendingExpired = true;
        fetchCart().then(function (c) { self.update(c); }).catch(function () {}).then(function () { self._pendingExpired = false; });
      }, PENDING_MS);
    }
    _clearPending() { if (this._pendingTimer) { clearTimeout(this._pendingTimer); this._pendingTimer = null; } }

    _hide(reason) {
      this.hidden = true;
      this.setAttribute('data-hidden-reason', reason);
    }

    /* ---------- Texte ---------- */
    _eur(cents, mode) {
      var v = cents / 100, whole = mode === 'ceil' ? Math.ceil(v - 1e-9) : Math.round(v);
      var cc = this._cfg.currencyCode;
      return whole.toLocaleString('de-DE') + ' ' + (cc || '€'); // Zeichen ODER Code, nie beides ("50 €" bzw. "50 EUR")
    }
    _pct(p) { return p + ' %'; }

    _texts(total, max, reachedCount) {
      var cfg = this._cfg, T = cfg.t, tiers = cfg.tiers, n = tiers.length, self = this;
      var next = tiers[reachedCount], last = reachedCount ? tiers[reachedCount - 1] : null, done = !next;
      var html, ariaTail;
      var lost = !done && this._maxReached() > reachedCount;
      if (cfg.mode === 'gift') {
        if (done) {
          html = n === 1 ? fill(T.g_done_one, { name: esc(last.longName || last.name) })
            : n === 2 ? fill(T.g_done_two, { name1: esc(tiers[0].name), name2: esc(tiers[1].name) })
            : T.g_done_three;
        } else {
          var r = next.threshold - total, amount = '<strong>' + esc(this._eur(r, 'ceil')) + '</strong>';
          var lead = last ? fill(T.g_lead, { name: esc(last.name) }) + ' ' : '';
          var val = next.value ? esc(this._eur(next.value)) : null;
          if (lost) html = lead + fill(T.g_lost, { amount: amount, name: esc(next.name) });
          else if (r <= cfg.near) html = lead + fill(T.g_near, { amount: amount, name: esc(next.name) });
          else if (last) html = lead + fill(val ? T.g_far_next : T.g_far_plain, { amount: amount, name: esc(next.name), value: val });
          else if (n === 1 || !val) html = fill(n === 1 ? T.g_far_one : T.g_far_plain, { amount: amount, name: esc(next.longName || next.name) });
          else html = fill(T.g_far_first, { amount: amount, name: esc(next.longName || next.name), value: val });
        }
        ariaTail = done ? T.aria_done : fill(T.aria_next, { amount: this._eur(next.threshold - total, 'ceil'), name: next.name });
      } else {
        var active = last ? last.pct : (cfg.base || 0);
        if (done) html = fill(T.p_done, { pct: this._pct(last.pct) });
        else {
          var r2 = next.threshold - total, amount2 = '<strong>' + esc(this._eur(r2, 'ceil')) + '</strong>';
          var lead2 = active ? fill(T.p_lead, { pct: this._pct(active) }) + ' ' : '';
          if (lost) html = lead2 + fill(T.p_lost, { amount: amount2, pct: this._pct(next.pct) });
          else if (r2 <= cfg.near) html = lead2 + fill(T.p_near, { amount: amount2, pct: this._pct(next.pct) });
          else if (active) html = lead2 + fill(T.p_next, { amount: amount2, pct: this._pct(next.pct) });
          else html = fill(this._hasExcl ? T.p_next : T.p_far, { amount: amount2, pct: this._pct(next.pct) });
        }
        ariaTail = done ? T.aria_done : fill(T.aria_next, { amount: this._eur(next.threshold - total, 'ceil'), name: this._pct(next.pct) });
      }
      var aria = fill(T.aria, { total: self._eur(total), max: self._eur(max) }) + ariaTail;
      return { html: html, aria: aria, done: done };
    }

    /* "wieder dabei / wieder aktiv": hoechste in dieser Sitzung erreichte Stufe je Aktion */
    _storeKey() { return 'olv_tier_max_' + this._cfg.mode + '_' + this._cfg.tiers.map(function (t) { return t.threshold; }).join('-'); }
    _maxReached() { try { return parseInt(sessionStorage.getItem(this._storeKey()) || '0', 10) || 0; } catch (e) { return 0; } }
    _noteReached(count) { try { if (count > this._maxReached()) sessionStorage.setItem(this._storeKey(), String(count)); } catch (e) {} }

    /* ---------- DOM ---------- */
    _layoutKind() { return this._cfg.mode === 'gift' && this._cfg.tiers.length === 1 ? 'single' : 'multi'; }

    _build() {
      var cfg = this._cfg, T = cfg.t, kind = this._layoutKind(), self = this;
      var msg = '<div class="otb-msg"><span class="otb-done" aria-hidden="true">' + CHECK + '</span><p class="otb-text" aria-live="polite"></p></div>';
      var html;
      if (kind === 'single') {
        var t = cfg.tiers[0];
        html = '<div class="otb-single"><div class="otb-main">' + msg +
          '<div class="otb-track" role="progressbar" aria-valuemin="0"><div class="otb-fill"></div></div></div>' +
          '<div class="otb-tilecol"><div class="otb-tile" data-i="0"><div class="otb-tile__box">' + this._imgHtml(t) + '</div>' +
          '<span class="otb-lock" aria-hidden="true">' + LOCK + '</span><span class="otb-tick" aria-hidden="true">' + CHECK + '</span></div>' +
          '<span class="otb-tile__label"></span></div></div>';
      } else {
        var stops = '', labels = '';
        if (cfg.mode === 'pct' && cfg.base > 0) {
          stops += '<div class="otb-stop otb-stop--pct otb-stop--base is-reached" data-base><span class="otb-stop__pct">' + esc(this._pct(cfg.base)) + '</span></div>';
          labels += '<span class="otb-label otb-label--base is-reached" data-base>' + esc(T.for_all) + '</span>';
        }
        cfg.tiers.forEach(function (t, i) {
          if (cfg.mode === 'pct') stops += '<div class="otb-stop otb-stop--pct" data-i="' + i + '"><span class="otb-stop__pct">' + esc(self._pct(t.pct)) + '</span></div>';
          else stops += '<div class="otb-stop otb-stop--gift" data-i="' + i + '"><div class="otb-stop__box">' + self._imgHtml(t) + '</div>' +
            '<span class="otb-lock" aria-hidden="true">' + LOCK + '</span><span class="otb-tick" aria-hidden="true">' + CHECK + '</span></div>';
          labels += '<span class="otb-label" data-i="' + i + '"></span>';
        });
        html = '<div class="otb-multi">' + msg + '<div class="otb-scale"><div class="otb-zone" role="progressbar" aria-valuemin="0">' +
          '<div class="otb-track"><div class="otb-fill"></div></div>' + stops + '</div><div class="otb-labels">' + labels + '</div></div></div>';
      }
      this.classList.add('otb-noanim');
      this.innerHTML = html;
      this._built = kind + '|' + cfg.mode;
      this._zone = this.querySelector('.otb-zone');
      if (this._zone && window.ResizeObserver) {
        if (this._ro) this._ro.disconnect();
        this._ro = new ResizeObserver(function () { self._place(); });
        this._ro.observe(this._zone);
      }
    }

    _imgHtml(t) {
      return t.img ? '<img src="' + esc(t.img) + '" alt="' + esc(t.name || t.longName) + '" loading="lazy" width="80" height="80">' : '<span class="otb-noimg"></span>';
    }

    /* Haltepunkte in px setzen: Stufe bei Schwelle/max, letzte buendig am Ende, Basis bei 0; liegt ein
       Haltepunkt naeher als MIN_GAP am naechsten, rueckt er nach links. Die Fuellung bleibt maßstaeblich. */
    _place() {
      var zone = this._zone; if (!zone) return;
      var cfg = this._cfg, W = zone.clientWidth, tiers = cfg.tiers, n = tiers.length, max = tiers[n - 1].threshold;
      if (!W) return;
      var self = this;
      var c = tiers.map(function (t, i) { return i === n - 1 ? W - STOP / 2 : W * t.threshold / max; });
      /* Label-Breiten: die Spezifikation nennt 48 px Mitte-zu-Mitte; "Geschenkt" (11 px) ist aber ~54 px breit und
         wuerde sich bei engen Schwellen ueberlappen. Deshalb rueckt der vordere Haltepunkt so weit, dass mindestens
         48 px UND die Labels mit 6 px Luft nebeneinander passen. Die letzte Stufe steht buendig am Ende. */
      var lw = tiers.map(function (t, i) { var l = self.querySelector('.otb-label[data-i="' + i + '"]'); return l ? l.offsetWidth : 0; });
      for (var i = n - 2; i >= 0; i--) {
        var nextLeft = i + 1 === n - 1 ? W - lw[i + 1] : c[i + 1] - lw[i + 1] / 2;
        c[i] = Math.min(c[i], c[i + 1] - MIN_GAP, nextLeft - 6 - lw[i] / 2);
      }
      c.forEach(function (x, i) {
        var s = self.querySelector('.otb-stop[data-i="' + i + '"]'), l = self.querySelector('.otb-label[data-i="' + i + '"]');
        if (s) s.style.left = (x - STOP / 2) + 'px';
        if (l) { if (i === n - 1) { l.style.left = W + 'px'; l.style.transform = 'translateX(-100%)'; } else { l.style.left = x + 'px'; l.style.transform = 'translateX(-50%)'; } }
      });
    }

    _render(total, max, reachedCount) {
      var cfg = this._cfg, T = cfg.t, kind = this._layoutKind();
      if (this._built !== kind + '|' + cfg.mode) this._build();
      this._noteReached(reachedCount);
      var tx = this._texts(total, max, reachedCount);
      var ratio = total <= 0 ? 0 : Math.min(1, Math.max(total / max, 0.04));

      this.classList.toggle('is-done', tx.done);
      var p = this.querySelector('.otb-text');
      if (p.innerHTML !== tx.html) p.innerHTML = tx.html;
      var bar = this.querySelector('[role="progressbar"]');
      bar.setAttribute('aria-valuemax', Math.round(max / 100));
      bar.setAttribute('aria-valuenow', Math.round(total / 100));
      bar.setAttribute('aria-valuetext', tx.aria);
      this.querySelector('.otb-fill').style.width = (ratio * 100) + '%';

      var self = this;
      if (kind === 'single') {
        var t = cfg.tiers[0], ok = reachedCount >= 1;
        this.querySelector('.otb-tile').classList.toggle('is-reached', ok);
        this.querySelector('.otb-tile__label').textContent = ok ? T.gifted : (t.value ? fill(T.value, { value: this._eur(t.value) }) : '');
      } else {
        cfg.tiers.forEach(function (t, i) {
          var ok = i < reachedCount;
          var s = self.querySelector('.otb-stop[data-i="' + i + '"]'), l = self.querySelector('.otb-label[data-i="' + i + '"]');
          s.classList.toggle('is-reached', ok);
          l.classList.toggle('is-reached', ok);
          l.textContent = cfg.mode === 'gift' && ok ? T.gifted : fill(T.from, { amount: self._eur(t.threshold) });
        });
        this._place();
      }

      this.removeAttribute('data-hidden-reason');
      this.hidden = false;
      if (this.classList.contains('otb-noanim')) {
        /* Startzustand ohne Transition festschreiben (Reflow), danach Transitions fuer alle weiteren Updates an.
           Kein requestAnimationFrame: das pausiert in Hintergrund-Tabs und liesse die Animation dauerhaft aus. */
        void this.offsetWidth;
        this.classList.remove('otb-noanim');
      }
    }
  };

  if (!customElements.get('olv-tier-bar')) customElements.define('olv-tier-bar', OlvTierBar);

  /* ---------- Warenkorb-Events (einmal global, gelten fuer alle Instanzen) ---------- */
  function updateAll(cart) { for (var k in REG) { if (REG.hasOwnProperty(k)) REG[k].update(cart); } }

  /* ---------- Drawer und /cart nachziehen (20.10.2026, Abnahme 28.09. Punkt 7, Fehlerbild 2) ----------
     Problem: Bei einem Fensterwechsel (Staffel oder Geschenk-Slot) bei offener Seite oder nach einer Aenderung in
     einem anderen Tab zeigte der Balken den neuen Stand, Drawer, /cart, Summenblock und Zeilenpreise den alten.
     Loesung wie im Gift-Watcher (syncDrawer/syncCartPage): Signatur der gerenderten Section (data-olv-cart-sig in
     sections/cart-drawer.liquid und sections/main-cart.liquid, total_price + Zeilenschluessel) gegen /cart.js
     vergleichen und nur bei Abweichung die Section per Section Rendering API holen und ihren Inhalt tauschen.
     Bewusst NICHT cart:refresh: das loest bei Impact einen eigenen Drawer-Abruf aus und startet den Gift-Watcher
     (mehrere /cart.js), und Impacts Neuaufbau war laut Gift-Watcher-Notiz vom 01.10. nicht verlaesslich. Kein
     Seiten-Reload: Drawer bleibt offen (nur seine Kinder werden getauscht), Scrollposition bleibt.
     Ausloeser: (1) Fenstergrenze, ein globaler Timer fuer alle Instanzen, SYNC_DELAY nach der Grenze ein /cart.js.
     (2) Tab wird wieder sichtbar: ein /cart.js; neu gezeichnet nur, wenn sich total_price, item_count oder die
     Allocations gegenueber dem zuletzt gesehenen Stand geaendert haben. Auf /cart uebernimmt das bei laufendem
     Gift-Watcher dieser selbst (eigener visibilitychange), hier dann nur der Drawer. */
  function fullSig(c) {
    var it = (c && c.items) || [], out = [];
    for (var i = 0; i < it.length; i++) {
      var a = it[i].line_level_discount_allocations || [], al = [];
      for (var j = 0; j < a.length; j++) al.push((a[j].discount_application && a[j].discount_application.title) + '=' + a[j].amount);
      out.push(it[i].key + ':' + it[i].quantity + '[' + al.join(';') + ']');
    }
    return (c ? c.total_price + '|' + c.item_count : '') + '|' + out.join(',');
  }
  function viewSig(c) {
    var it = (c && c.items) || [], out = [];
    for (var i = 0; i < it.length; i++) out.push(it[i].key + ':' + it[i].quantity);
    return (c ? c.total_price : 0) + '|' + out.join(',');
  }
  function scheduleBoundary(next, now, isPct) {
    if (boundaryAt === next && boundaryTimer) return;
    var ms = (next - now) * 1000 + SYNC_DELAY;
    if (ms >= 2147000000) return;
    if (boundaryTimer) clearTimeout(boundaryTimer);
    boundaryAt = next;
    boundaryTimer = setTimeout(function () {
      boundaryTimer = null; boundaryAt = null;
      (isPct ? forceRecalc() : fetchCart()).then(function (c) { syncViews(c, true); }).catch(function () {});
    }, ms);
  }
  /* ---------- Neuberechnung an der Staffel-Fenstergrenze erzwingen (21.10.2026) ----------
     Gemessen im Testlauf 21.10. 10:00 bis 10:10 (Stefan, eingeloggt): Shopify rechnet automatische Rabatte an
     ihrer Start- und Endminute NICHT von selbst neu. /cart.js lieferte um 10:00:24 und 10:01:31 weiter den Stand ohne
     Staffel (Header x-cartjs-cache: 1); zum Ende blieb der Rabatt auch nach Reload und nach POST /cart/update.js {}
     stehen. Erst eine echte Aenderung (Menge 2 und zurueck) rechnete neu.
     Deshalb einmal pro Staffel-Grenze, NICHT bei Tab-Rueckkehr, eine Mutation, die den Warenkorb nicht sichtbar
     veraendert, Stufe fuer Stufe bis der Stand passt:
       1. Cart-Attribut _olv_sync mit Zeitstempel setzen (Unterstrich: im Checkout nicht sichtbar).
       2. Falls der Stand danach noch nicht passt: change.js mit UNVERAENDERTER Menge auf eine Zeile ohne Properties
          (nie Geschenkzeile, Gravur-Zeile oder Pfanne mit Gravur-Kopplung, nie Gutschein). Keine Mengenaenderung,
          also keine Splits und keine Doppelzeilen.
       Danach wird _olv_sync wieder entfernt (leerer Wert), das ist zugleich ein weiterer Neuberechnungsanstoss.
     „Passt“: Staffel aktiv und Basis ueber der ersten Schwelle -> Staffel-Allocation da; Staffel aus -> keine da.
     Gift-Watcher und Gravur-Watcher reagieren auf jede /cart/-Mutation mit einem eigenen, idempotenten Durchlauf.
     Bleibt der Stand falsch, nur console.warn: die Kasse rechnet beim Checkout ohnehin neu. */
  function postJSON(path, body) {
    return fetch(ROOT + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error(path + ' ' + r.status); return r; });
  }
  function recalcOk(c) {
    var inst = REG.drawer || REG.page;
    if (!inst || !inst._raw || !inst._raw.pct || !c || !c.item_count) return true;
    var pct = inst._raw.pct, pw = pct.windows || [], now = srvNow();
    var active = pw.length > 0 && pw.some(function (w) { return inWindow(w, now); });
    var has = inst._actualPct(c) > 0;
    if (!active) return !has;
    var cfg = { mode: 'pct', excl: pct.excl || [], exclTypes: pct.exclTypes || [] }, tiers = pct.tiers || [];
    var min = tiers.length ? tiers[0].threshold : Infinity;
    return baseTotal(c, cfg) >= min ? has : true;
  }
  function forceRecalc() {
    return fetchCart().then(function (c0) {
      if (!c0 || !c0.item_count) return c0;
      return postJSON('cart/update.js', { attributes: { _olv_sync: new Date().toISOString() } }).then(fetchCart).then(function (c1) {
        if (recalcOk(c1)) return c1;
        var ln = null, it = c1.items || [];
        for (var i = 0; i < it.length; i++) {
          var props = it[i].properties || {}, hasProps = false;
          for (var k in props) { if (props.hasOwnProperty(k) && props[k] != null && props[k] !== '') { hasProps = true; break; } }
          if (!hasProps && !it[i].gift_card) { ln = it[i]; break; }
        }
        if (!ln) return c1;
        return postJSON('cart/change.js', { id: ln.key, quantity: ln.quantity }).then(fetchCart).then(function (c2) {
          if (!recalcOk(c2)) console.warn('[Staffel-Balken] Shopify hat die Staffel an der Fenstergrenze nicht neu berechnet; die Kasse rechnet beim Checkout neu.');
          return c2;
        });
      }).then(function (c) {
        return postJSON('cart/update.js', { attributes: { _olv_sync: '' } }).then(fetchCart).catch(function () { return c; });
      });
    }).catch(function () { return fetchCart(); });
  }
  function sectionHtml(url, id) {
    /* KEIN Accept: application/json, sonst liefert /cart das Warenkorb-JSON statt der Sections (wie Gift-Watcher) */
    return fetch(url + (url.indexOf('?') >= 0 ? '&' : '?') + 'sections=' + encodeURIComponent(id))
      .then(function (r) { return r.json(); }).then(function (data) { return data && data[id]; });
  }
  function cartPageSection() {
    var tv = window.themeVariables;
    if (!(tv && tv.settings && tv.settings.pageType === 'cart')) return null;
    var el = document.querySelector('.shopify-section--main-cart') || document.querySelector('[id^="shopify-section-template--"][id$="__main"]');
    return (el && el.id) ? el : null;
  }
  function syncViews(c, withPage) {
    var sig = viewSig(c), my = ++syncSeq;
    document.querySelectorAll('cart-count').forEach(function (el) { try { el.itemCount = c.item_count; } catch (e) {} });
    updateAll(c);
    var d = document.querySelector('cart-drawer'), dsec = d && d.closest('.shopify-section'), dsig = d && d.querySelector('[data-olv-cart-sig]');
    if (dsec && dsec.id && dsig && dsig.getAttribute('data-olv-cart-sig') !== sig) {
      var did = dsec.id.replace('shopify-section-', '');
      sectionHtml(ROOT, did).then(function (html) {
        if (my !== syncSeq || !html) return;
        var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('cart-drawer'), cur = document.querySelector('cart-drawer');
        if (fresh && cur) cur.replaceChildren.apply(cur, Array.prototype.slice.call(document.importNode(fresh, true).childNodes));
      }).catch(function () {});
    }
    var psec = withPage ? cartPageSection() : null, psig = psec && psec.querySelector('[data-olv-cart-sig]');
    if (psec && psig && psig.getAttribute('data-olv-cart-sig') !== sig) refreshCartPage(psec, my);
  }
  function refreshCartPage(sec, my) {
    var note = sec.querySelector('textarea[name="note"]');
    /* Kunde tippt gerade den Bestellhinweis: erst nach dem Verlassen des Felds tauschen (wie Gift-Watcher) */
    if (note && document.activeElement === note) { note.addEventListener('blur', function () { if (my === syncSeq) refreshCartPage(sec, my); }, { once: true }); return; }
    var id = sec.id.replace('shopify-section-', '');
    sectionHtml(location.pathname, id).then(function (html) {
      if (my !== syncSeq || !html) return;
      var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('shopify-section-' + id), cur = document.getElementById('shopify-section-' + id);
      if (!fresh || !cur) return;
      var oldNote = cur.querySelector('textarea[name="note"]'), val = oldNote ? oldNote.value : null;
      cur.replaceChildren.apply(cur, Array.prototype.slice.call(document.importNode(fresh, true).childNodes));
      var newNote = cur.querySelector('textarea[name="note"]'); if (newNote && val !== null) newNote.value = val;
    }).catch(function () {});
  }
  var visBusy = false;
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible' || visBusy) return;
    visBusy = true;
    fetchCart().then(function (c) {
      if (fullSig(c) === lastSig) return;
      /* /cart mit Gift-Watcher: der gleicht die Seite selbst ab (eigener visibilitychange) */
      syncViews(c, !window.__olavGiftWatcher);
    }).catch(function () {}).then(function () { visBusy = false; });
  });
  document.addEventListener('cart:change', function (e) {
    var c = e.detail && e.detail.cart;
    /* Frisch gerenderte Sections (Drawer, /cart) tragen die Tag-Ausschluesse des neuen Warenkorbs: vor dem Rechnen lesen */
    var secs = c && c.sections;
    if (secs) for (var sid in secs) { if (secs.hasOwnProperty(sid) && typeof secs[sid] === 'string') { var m = secs[sid].match(/data-otb-excl>([^<]*)</); if (m) noteTagExcl(m[1]); } }
    if (c && c.items && typeof c.item_count === 'number') updateAll(c);
    else fetchCart().then(updateAll).catch(function () {});
  });
  document.addEventListener('cart:refresh', function () { fetchCart().then(updateAll).catch(function () {}); });

  /* ---------- Drawer: Zeile beim Mengenwechsel nicht kurz verschwinden lassen (22.10.2026) ----------
     Ursache (Preview, eingeloggt mit TEST-Staffel): Aendert ein Mengenwechsel die Rabattzuordnung einer Zeile (Staffel
     greift, Stufe wechselt), vergibt Shopify einen NEUEN Zeilenschluessel. Impact sucht die Zeile danach unter dem alten
     Schluessel (theme.js, line-item-quantity: items.filter(key === lineKey)), findet sie nicht, meldet Menge 0 und
     LineItem klappt die Zeile weg und entfernt sie. 1,25 s spaeter setzt Impact den neuen Drawer-Inhalt ein, die Zeile
     ist wieder da. Ausgeloggt (keine Staffel) bleibt der Schluessel gleich, gemessen 22.10.: kein Springen. Live trat
     es nur nicht auf, weil dort noch keine Staffel laeuft.
     Abhilfe ohne Eingriff in theme.js: Zielmenge aus line-item:will-change merken; kommt line-item:change mit Menge 0,
     obwohl der Kunde eine Menge > 0 gewaehlt hat, das Event in der Capture-Phase anhalten (nur das Wegklappen; cart:change
     und der Neuaufbau des Drawers laufen normal). Entfernen ueber „Loeschen“ oder Menge 0 bleibt unveraendert. */
  document.addEventListener('line-item:will-change', function (e) {
    var li = e.target;
    if (li && li.tagName === 'LINE-ITEM') li.__olvTarget = e.detail ? e.detail.targetQuantity : null;
  }, true);
  document.addEventListener('line-item:change', function (e) {
    var li = e.target, d = e.detail || {};
    if (!li || li.tagName !== 'LINE-ITEM' || d.quantity !== 0) return;
    if (typeof li.__olvTarget === 'number' && li.__olvTarget > 0 && d.cart && d.cart.item_count > 0) {
      e.stopPropagation();
      var pl = li.querySelector('pill-loader'); if (pl) pl.removeAttribute('aria-busy');
    }
  }, true);
})();
